import Navbar from './components/layouts/Navbar';
import Home from './components/layouts/Home';
import  {Provider} from "react-redux";
import store,{rrfProps} from "./store";
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import Explore from './components/gradients/Explore';
import Dashboard from './components/dashboard/Dashboard';
import AddGradient from './components/dashboard/AddGradient';
import { ReactReduxFirebaseProvider } from 'react-redux-firebase';
import PrivateRoute from "./components/dashboard/PrivateRoute";
import Login from "./components/dashboard/Login";
import {ToastContainer} from 'react-toastify';

const App = () =>{
  return (
    <Provider store={store}>
      <ReactReduxFirebaseProvider {...rrfProps}>
      <Router>
      <ToastContainer/>
      <Navbar/>
      <Switch>
        <Route exact path='/' component={Home}/>
        <Route exact path='/explore' component={Explore}/>
        <PrivateRoute exact path='/dashboard' component={Dashboard}/>
        <Route exact path='/addgradient' component={AddGradient}/>
        <Route exact path='/login' component={Login}/>
      </Switch>
      </Router>
      </ReactReduxFirebaseProvider>
    </Provider>
  );
}

export default App;
